import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { nvlObj, nvlString } from 'src/app/core/services/utils.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

    private refreshTokenInProgress = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(public authService: AuthService, private toast: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {

        return next.handle(this.checkToken(request)).pipe(
            catchError((err: HttpErrorResponse) => {
                const error = nvlObj(err);
                const tErrStr: any = nvlString(error.error.error);
                if (tErrStr.includes('Unexpected token') || tErrStr.includes('Invalid token')) {
                    this.toast.error('Token expired. Please Login again.', 'Authentication Failed', {
                        
                    }); 
                    const t = this;
                    setTimeout(function () {
                        // t.authService.logout();
                    }, 700)
                }

                if (error.status == 0) {
                    this.toast.error('Service not available. Please contact with administrator.', '', {
                        
                    });
                }
 
                if (
                    request.url.includes("refreshtoken") ||
                    request.url.includes("oauth/token")
                ) {
                    if (request.url.includes("refreshtoken")) {
                        this.authService.logout();
                    }
                    return throwError(error);
                }
                if (error.status !== 401) {
                    return throwError(error);
                }

                if (this.refreshTokenInProgress) {
                    return this.refreshTokenSubject.pipe(
                        filter(result => result !== null),
                        take(1),
                        switchMap(() => next.handle(this.checkToken(request)))
                    );
                } else {
                    this.refreshTokenInProgress = true;
                    this.refreshTokenSubject.next(null);
                    return this.authService
                        .refreshAccessToken().pipe(
                            switchMap((token: any) => {
                                this.refreshTokenInProgress = false;
                                this.refreshTokenSubject.next(token);
                                return next.handle(this.checkToken(request));
                            }),
                            catchError(() => {
                                this.refreshTokenInProgress = false;
                                this.authService.logout();
                                return throwError(error);
                            })
                        )
                }
            })
        );
    }

    public checkToken(request: any) {
        const accessToken = this.authService.getAccessToken();
        if (!accessToken || request.url.includes("oauth/token")) {
            return request;
        }
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${this.authService.getAccessToken()}`
            }
        });
    }

}
